export var EventCategory;
(function (EventCategory) {
    EventCategory["NIVEL_RIOS"] = "NIVEL_RIOS";
    EventCategory["AREA_ALAGAMENTO"] = "AREA_ALAGAMENTO";
    EventCategory["CHUVAS"] = "CHUVAS";
    EventCategory["BARRAGENS"] = "BARRAGENS";
    EventCategory["VENDAVAL"] = "VENDAVAL";
    EventCategory["INCENDIO"] = "INCENDIO";
    EventCategory["DESLIZAMENTO"] = "DESLIZAMENTO";
    EventCategory["PERDA_SOLO"] = "PERDA_SOLO";
    EventCategory["PRODUTOS_QUIMICOS"] = "PRODUTOS_QUIMICOS";
    EventCategory["TREMOR"] = "TREMOR";
})(EventCategory || (EventCategory = {}));
export var EventSubCategory;
(function (EventSubCategory) {
    // NÍVEL DOS RIOS
    EventSubCategory["BAIXO"] = "BAIXO";
    EventSubCategory["ALTO"] = "ALTO";
    EventSubCategory["TRANSBORDANDO"] = "TRANSBORDANDO";
    // ÁREA DE ALAGAMENTO
    EventSubCategory["TRANSITAVEL"] = "TRANSITAVEL";
    EventSubCategory["INTRANSITAVEL"] = "INTRANSITAVEL";
    // CHUVAS
    EventSubCategory["CHUVA_FRACA"] = "CHUVA_FRACA";
    EventSubCategory["CHUVA_MODERADA"] = "CHUVA_MODERADA";
    EventSubCategory["CHUVA_FORTE"] = "CHUVA_FORTE";
    EventSubCategory["ENXURRADA"] = "ENXURRADA";
    EventSubCategory["DANOS_ESTRUTURA"] = "DANOS_ESTRUTURA";
    EventSubCategory["PERDA_SOLO"] = "PERDA_SOLO";
    // BARRAGENS
    EventSubCategory["TRINCA"] = "TRINCA";
    EventSubCategory["FISSURA"] = "FISSURA";
    EventSubCategory["FUGA_AGUA"] = "FUGA_AGUA";
    EventSubCategory["VAZAMENTO"] = "VAZAMENTO";
    EventSubCategory["CRESCIMENTO_VEGETACAO"] = "CRESCIMENTO_VEGETACAO";
    EventSubCategory["OCUPACAO"] = "OCUPACAO";
    EventSubCategory["CONSTRUCAO_IRREGULAR"] = "CONSTRUCAO_IRREGULAR";
    // VENDAVAL
    EventSubCategory["QUEDA_ARVORES"] = "QUEDA_ARVORES";
    EventSubCategory["DANOS_REDE_ELETRICA"] = "DANOS_REDE_ELETRICA";
    EventSubCategory["DANOS_RESIDENCIAS"] = "DANOS_RESIDENCIAS";
    // INCÊNDIOS
    EventSubCategory["RISCO_VIDA"] = "RISCO_VIDA";
    EventSubCategory["PREJUIZO_MATERIAL"] = "PREJUIZO_MATERIAL";
    EventSubCategory["DEGRADACAO_AMBIENTAL"] = "DEGRADACAO_AMBIENTAL";
    EventSubCategory["IMPACTOS_SAUDE_PUBLICA"] = "IMPACTOS_SAUDE_PUBLICA";
    // DESLIZAMENTO
    EventSubCategory["DANOS_HUMANOS"] = "DANOS_HUMANOS";
    EventSubCategory["DANOS_MATERIAIS"] = "DANOS_MATERIAIS";
    EventSubCategory["DANOS_AMBIENTAIS"] = "DANOS_AMBIENTAIS";
    // PRODUTOS QUÍMICOS
    EventSubCategory["AGUA"] = "AGUA";
    EventSubCategory["AR"] = "AR";
    EventSubCategory["SOLO"] = "SOLO";
})(EventSubCategory || (EventSubCategory = {}));
